import { createContext } from 'react';

const ClusterContext = createContext({
  name: ""
});

export { ClusterContext };
//# sourceMappingURL=Cluster.esm.js.map
